import Vue from 'vue'
import injector from 'vue-inject'
import moment from 'moment'

require('../../start')

Vue.use(injector)

let api         = injector.get('api'),
    datetime    = injector.get('datetime'),
    status      = injector.get('status')

const state = {
    dailyMining: {},

    dailyMiningSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: []
    },

    futurocoinWithdraw: {}
}

const getters = {
    dailyMining: state => {
        return state.dailyMining
    },

    dailyMiningSettings: state => {
        return state.dailyMiningSettings
    },

    futurocoin: state => {
        return state.futurocoin
    },

    futurocoinWithdraw: state => {
        return state.futurocoinWithdraw
    },
}

const mutations = {
    /**
     * Set daily mining in store
     * @param state
     * @param data
     */
    setDailyMining (state, data) {
        if (data.results.length > 0) {
            Vue.set(state, 'dailyMining', data.results)
        } else {
            Vue.set(state, 'dailyMining', [])
        }
        Vue.set(state.dailyMiningSettings, 'currentPage', data.current_page);
        Vue.set(state.dailyMiningSettings, 'maxPerPage', data.max_per_page);
        Vue.set(state.dailyMiningSettings, 'numberOfPages', data.number_of_pages);
    },

    /**
     * Set futurocoin withdraw in store
     * @param state
     * @param data
     */
    setFuturocoinWithdraw (state, data) {
        Vue.set(state, 'futurocoinWithdraw', data)
    },
}

const actions = {

    /**
     * Get daily mining data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    async loadDailyMining ({ commit }, data) {

        if(!data) {
            return;
        }

        return new Promise((resolve, reject) => {
            let settings = Object.create(data)
            if (settings.params.sort) {
                let sort = []
                for (let field in data.params.sort) {
                    sort.push(data.params.sort[field])
                }
                settings.params.sort = sort
            }
            Vue.http.get(api.mining.history(settings.params)).then(response => {
                commit('setDailyMining', response.data)
                resolve()
            }, error => {
                status['status' + error.status]()
                reject()
            })
        })
    },

    /**
     * Set sorting in daily mining
     * @param field
     * @returns {Promise}
     */
    async dailyMiningSetSort ({},  field) {
        return new Promise((resolve) => {
            let sort = state.dailyMiningSettings.sort,
                isSet = false

            for (let sortId in sort) {
                if (!isSet && sort[sortId].field === field) {
                    isSet = sortId
                }
            }

            if (!isSet) {
                sort.push({
                    field: field,
                    order: 'ASC'
                })
            } else {
                sort[isSet].order = sort[isSet].order === 'DESC' ? 'ASC' : 'DESC'
            }

            Vue.set(state.dailyMiningSettings, 'sort', sort)

            resolve()
        })
    },

    /**
     * Set max number of items in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async dailyMiningSetItems ({}, data) {
        return new Promise((resolve) => {
            Vue.set(state.dailyMiningSettings, 'maxPerPage', data)

            resolve()
        })
    },

    /**
     * Set page in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async dailyMiningSetPage ({}, data) {
        return new Promise((resolve) => {

            Vue.set(state.dailyMiningSettings, 'currentPage', data)

            resolve()
        })
    },

    /**
     * Set date in daily mining
     * @param date
     * @returns {Promise}
     */
    async dailyMiningSetDate ({}, date) {
        return new Promise((resolve) => {

            let dates = date.split(' to ')

            if (dates[1]) {
                Vue.set(state.dailyMiningSettings, 'fromDate', datetime.localToUtc(dates[0]))
                Vue.set(state.dailyMiningSettings, 'toDate', datetime.localToUtc(dates[1]))
            } else {
                Vue.set(state.dailyMiningSettings, 'fromDate', datetime.localToUtc(dates[0]))
                Vue.set(state.dailyMiningSettings, 'toDate', datetime.localToUtc(moment().format()))
            }

            resolve()
        })
    },

    /**
     * Get futurocoin withdraw from api
     * @param commit
     * @returns {Promise.<void>}
     */
    async loadFuturocoinWithdraw ( { commit } ) {
        Vue.http.get(api.user.withdraw).then( response => {
            commit('setFuturocoinWithdraw', response.data.data)
        }, error => {
            status['status' + error.status]()
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/futurocoin.js